var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent pl-1" }, [
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _vm._m(0),
        _c("div", { staticClass: "field columns" }, [
          _c("div", { staticClass: "column is-half" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Username")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value.username,
                    expression: "value.username",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.$vv.entity.username.$error },
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  disabled: !_vm.value.isNew && _vm.isCustomerAdmin,
                },
                domProps: { value: _vm.value.username },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.value, "username", $event.target.value)
                  },
                },
              }),
              !_vm.$vv.entity.username.required
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Username is required "),
                  ])
                : _vm._e(),
              !_vm.$vv.entity.username.isUniqueUsername
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("This username is already in use. "),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "column is-half" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Email")]),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value.email,
                    expression: "value.email",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.$vv.entity.email.$error },
                attrs: { type: "text", autocomplete: "new-email" },
                domProps: { value: _vm.value.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.value, "email", $event.target.value)
                  },
                },
              }),
              !_vm.$vv.entity.email.email
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Please enter a valid email "),
                  ])
                : _vm._e(),
              !_vm.$vv.entity.email.required
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Email is required "),
                  ])
                : _vm._e(),
              !_vm.$vv.entity.email.isUniqueEmail
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("This email is already in use. "),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        !_vm.value.isNew
          ? _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half pb-0" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Password")]),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary tooltip",
                    attrs: { "data-tooltip": "Reset Password" },
                    on: { click: _vm.toggleResetPasswordModal },
                  },
                  [_c("span", [_vm._v("Reset Password")])]
                ),
              ]),
            ])
          : _c("div", { staticClass: "field columns" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Password")]),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    (_vm.showPassword ? "text" : "password") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.password,
                              expression: "value.password",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.password.$error
                            ? ""
                            : "is-danger",
                          attrs: {
                            autocomplete: "new-password",
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.value.password)
                              ? _vm._i(_vm.value.password, null) > -1
                              : _vm.value.password,
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.validatePassword(_vm.value.password)
                            },
                            change: function ($event) {
                              var $$a = _vm.value.password,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.value,
                                      "password",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.value,
                                      "password",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.value, "password", $$c)
                              }
                            },
                          },
                        })
                      : (_vm.showPassword ? "text" : "password") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.password,
                              expression: "value.password",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.password.$error
                            ? ""
                            : "is-danger",
                          attrs: {
                            autocomplete: "new-password",
                            type: "radio",
                          },
                          domProps: {
                            checked: _vm._q(_vm.value.password, null),
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.validatePassword(_vm.value.password)
                            },
                            change: function ($event) {
                              return _vm.$set(_vm.value, "password", null)
                            },
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.password,
                              expression: "value.password",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.password.$error
                            ? ""
                            : "is-danger",
                          attrs: {
                            autocomplete: "new-password",
                            type: _vm.showPassword ? "text" : "password",
                          },
                          domProps: { value: _vm.value.password },
                          on: {
                            blur: function ($event) {
                              return _vm.validatePassword(_vm.value.password)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.value,
                                "password",
                                $event.target.value
                              )
                            },
                          },
                        }),
                    !_vm.$vv.entity.password.required && _vm.value.isNew
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Password is required "),
                        ])
                      : _vm._e(),
                    !_vm.passwordMeetsCriteria
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(" " + _vm._s(_vm.passwordMessage) + " "),
                        ])
                      : _vm._e(),
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            _vm.showPassword = !_vm.showPassword
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon has-text-primary" }, [
                          _c("span", { staticClass: "mso mso-24px" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.showPassword
                                    ? "visibility"
                                    : "visibility_off"
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-half" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Confirm Password"),
                ]),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    (_vm.showConfirmPassword ? "text" : "password") ===
                    "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.confirmNewPassword,
                              expression: "value.confirmNewPassword",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.confirmNewPassword.$error
                            ? ""
                            : "is-danger",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.value.confirmNewPassword)
                              ? _vm._i(_vm.value.confirmNewPassword, null) > -1
                              : _vm.value.confirmNewPassword,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.value.confirmNewPassword,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.value,
                                      "confirmNewPassword",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.value,
                                      "confirmNewPassword",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.value, "confirmNewPassword", $$c)
                              }
                            },
                          },
                        })
                      : (_vm.showConfirmPassword ? "text" : "password") ===
                        "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.confirmNewPassword,
                              expression: "value.confirmNewPassword",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.confirmNewPassword.$error
                            ? ""
                            : "is-danger",
                          attrs: { type: "radio" },
                          domProps: {
                            checked: _vm._q(_vm.value.confirmNewPassword, null),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.value,
                                "confirmNewPassword",
                                null
                              )
                            },
                          },
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.confirmNewPassword,
                              expression: "value.confirmNewPassword",
                            },
                          ],
                          staticClass: "input",
                          class: !_vm.$vv.entity.confirmNewPassword.$error
                            ? ""
                            : "is-danger",
                          attrs: {
                            type: _vm.showConfirmPassword ? "text" : "password",
                          },
                          domProps: { value: _vm.value.confirmNewPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.value,
                                "confirmNewPassword",
                                $event.target.value
                              )
                            },
                          },
                        }),
                    _vm.value.password &&
                    _vm.value.confirmNewPassword &&
                    !_vm.passwordsMatch &&
                    _vm.value.isNew
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Passwords do not match."),
                        ])
                      : _vm._e(),
                    !_vm.$vv.entity.confirmNewPassword.required &&
                    _vm.value.isNew
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Confirm Password is required "),
                        ])
                      : _vm._e(),
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            _vm.showConfirmPassword = !_vm.showConfirmPassword
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon has-text-primary" }, [
                          _c("span", { staticClass: "mso mso-24px" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.showConfirmPassword
                                    ? "visibility"
                                    : "visibility_off"
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
        _c("div", { staticClass: "field columns" }, [
          _c("div", { staticClass: "column is-half pb-0" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Status")]),
            _c("div", [
              _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.active,
                      expression: "value.active",
                    },
                  ],
                  attrs: {
                    id: "chk-pretty-customer-type",
                    name: "chk-pretty-customer-type",
                    type: "radio",
                  },
                  domProps: {
                    value: true,
                    checked: _vm._q(_vm.value.active, true),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.value, "active", true)
                    },
                  },
                }),
                _vm._m(1),
              ]),
              _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.active,
                      expression: "value.active",
                    },
                  ],
                  attrs: {
                    id: "chk-pretty-customer-type",
                    name: "chk-pretty-customer-type",
                    type: "radio",
                  },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.value.active, false),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.value, "active", false)
                    },
                  },
                }),
                _vm._m(2),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field columns" }, [
          _c("div", { staticClass: "column is-half pb-0" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Roles")]),
            _c(
              "div",
              { key: _vm.rolesKey },
              _vm._l(_vm.localRoles, function (role, index) {
                return _c("div", { key: index }, [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-curve p-smooth m-0 p-bigger",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: role.active,
                                expression: "role.active",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(role.active)
                                ? _vm._i(role.active, null) > -1
                                : role.active,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = role.active,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          role,
                                          "active",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          role,
                                          "active",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(role, "active", $$c)
                                  }
                                },
                                function ($event) {
                                  return _vm.validateRoles(role)
                                },
                              ],
                            },
                          }),
                          _vm._m(3, true),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "column is-four-fifths" }, [
                      _vm._v(" " + _vm._s(role.label) + " "),
                      role.name === "CustomerMobile"
                        ? _c(
                            "span",
                            { staticClass: "tag is-info is-light ml-2" },
                            [
                              _vm._v(
                                " Mobile users can only flexiquote mobile app and don't have access to the web app. "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
        _c("reset-password-modal", {
          attrs: { active: _vm.showResetPasswordModal },
          on: {
            close: function ($event) {
              _vm.showResetPasswordModal = false
            },
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Active")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Inactive")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }